import { useEffect, useState } from "react";
import { Camera, X } from "lucide-react";
import { cameraPermissionState } from "./scanner/cameraStream";

const IOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

export default function CameraPermissionTip() {
  const [state, setState] = useState("unknown");
  const [hidden, setHidden] = useState(() => localStorage.getItem("supplivo_cam_tip_hidden") === "1");
  useEffect(() => { cameraPermissionState().then(setState); }, []);
  if (hidden || state === "granted") return null;
  const dismiss = () => { localStorage.setItem("supplivo_cam_tip_hidden", "1"); setHidden(true); };
  return (
    <div className="relative flex items-start gap-3 text-sm bg-white border border-slate-200 rounded-lg p-3 lg:hidden" data-testid="camera-permission-tip">
      <Camera className="h-5 w-5 text-emerald-600 shrink-0 mt-0.5" />
      <div className="text-slate-700 pr-6">
        <p className="font-medium text-slate-900">Camera permission — allow once</p>
        {IOS ? (
          <p className="mt-0.5">When Safari asks, tap <b>Allow</b>. To stop it asking on every visit: <b>Settings → Safari → Camera → Allow</b>. Supplivo also keeps the camera ready between scans while the app is open.</p>
        ) : (
          <p className="mt-0.5">When Chrome asks, choose <b>“Allow”</b> (not “Only this time”) — it then won't ask again.</p>
        )}
      </div>
      <button onClick={dismiss} className="absolute top-2 right-2 p-1 text-slate-400" data-testid="camera-tip-dismiss" aria-label="Dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
}
